module.exports = __webpack_public_path__ + "static/media/irel.4b52a407.png";